import { Reducer } from 'redux'
import {
  ActionTypes,
  VERIFICATION_ACTIONS,
  SCREENS,
  ResidentStatus,
  VerificationFlows,
  UserDetails,
  RetrievedDetails,
  MyInfoOnlyDetails,
  FormOptions,
} from './types'

const initialState = {
  userDetails: {
    fullName: undefined,
    dateOfBirth: undefined,
    countryOfBirth: undefined,
    nationality: undefined,
    gender: undefined,
    addressLine1: undefined,
    addressLine2: undefined,
    country: undefined,
    city: undefined,
    postalCode: undefined,
    idNumber: undefined,
    dateOfIssue: undefined,
    expiryDate: undefined,
    occupation: undefined,
    employmentSector: undefined,
    employer: undefined,
    expectedTransactionAmount: undefined,
    expectedTotalTransaction: undefined,
    expectedTransactionFrequency: undefined,
  },
  myInfoOnlyDetails: {
    race: undefined,
    residentialStatus: undefined,
    aliasName: undefined,
    noticesOfAssessment: [],
    cpfBalance: undefined,
    cpfContributions: [],
    passstatusLastupdated: undefined,
    error: undefined,
  },
  residentStatus: undefined,
  isResident: true,
  flow: undefined,
  error: '',
  screen: undefined,
  kycRejectedReason: '',
  retrievedDetails: undefined,
  formOptions: {
    countries: [],
    nationalities: [],
    races: [],
    genders: [],
    occupations: [],
    employmentSectors: [],
    annualIncomes: [],
    expectedTransactionAmounts: [],
    expectedTotalTransactions: [],
    expectedTransactionFrequencies: [],
  },
}

type State = {
  userDetails: UserDetails
  residentStatus: ResidentStatus
  isResident: boolean
  flow: VerificationFlows
  error: string
  screen?: SCREENS
  kycRejectedReason: string
  retrievedDetails?: RetrievedDetails
  myInfoOnlyDetails: MyInfoOnlyDetails
  formOptions: FormOptions
}

export const verification: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case VERIFICATION_ACTIONS.SET_RESIDENT_STATUS: {
      return {
        ...state,
        residentStatus: action.status,
      }
    }

    case VERIFICATION_ACTIONS.SET_FLOW: {
      return {
        ...state,
        flow: action.flow,
      }
    }

    case VERIFICATION_ACTIONS.SET_USER_DETAILS: {
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          [action.key]: action.value,
        },
      }
    }

    case VERIFICATION_ACTIONS.UPDATE_USER: {
      const errorMsg =
        action.error === 'Same request is still processing'
          ? 'Please try again in a minute as we are still processing.'
          : action.error
      return {
        ...state,
        error: errorMsg,
      }
    }

    case VERIFICATION_ACTIONS.SET_IS_RESIDENT: {
      return {
        ...state,
        isResident: action.isResident,
      }
    }

    case VERIFICATION_ACTIONS.SET_SCREEN: {
      return {
        ...state,
        screen: action.screen,
      }
    }

    case VERIFICATION_ACTIONS.SET_MULTIPLE_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.userDetails,
      }
    }

    case VERIFICATION_ACTIONS.SET_KYC_REJECTED_REASON: {
      return {
        ...state,
        kycRejectedReason: action.kycRejectedReason,
      }
    }

    case VERIFICATION_ACTIONS.SET_RETRIEVED_DETAILS: {
      return {
        ...state,
        retrievedDetails: action.retrievedDetails,
      }
    }

    case VERIFICATION_ACTIONS.SET_ERROR: {
      const errorMsg =
        action.error === 'Same request is still processing'
          ? 'Please try again in a minute as we are still processing.'
          : action.error
      return {
        ...state,
        error: errorMsg,
      }
    }

    case VERIFICATION_ACTIONS.SET_MY_INFO_ONLY_DETAILS: {
      return {
        ...state,
        myInfoOnlyDetails: action.myInfoOnlyDetails,
      }
    }

    case VERIFICATION_ACTIONS.SET_FORM_OPTIONS: {
      return {
        ...state,
        formOptions: action.formOptions,
      }
    }

    default:
      return state
  }
}
